module.exports = __webpack_public_path__ + "static/media/ar_vip.8b586c3f.svg";